export default "__VITE_ASSET__CdIVSK75__"